// extracted by mini-css-extract-plugin
export default {"leaderboardModelLink":"Leaderboard_leaderboardModelLink__1XQHg","leaderboardModelContaminated":"Leaderboard_leaderboardModelContaminated__2Vw2W"};